export function setupSlides() {
    const body = document.querySelector("body");
    const meta = document.querySelector('meta[name="viewport"]');
    meta.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
    body.innerHTML = `
        <div class="reveal">
            <div class="slides">
                <section id="loading" class="center">
                    <p>Loading...</p>
                </section>
            </div>
        </div>
    `;
}
